<template>
    <div id="wrapper">
        <SidebarView :term-deposits-reports="true" :operation="true" :operations-visible="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <TopbarView />
                <div class="container">
                    <div class="card card-shape home-box">
                        <div class="card-header">
                            <div class="row align-items-center">
                                <div class="col-6">
                                    <h6 class="m-0 fw-bold text-green">
                                        Fixed-Term Deposit Reports
                                    </h6>
                                </div>
                                <div class="col-6 text-end">
                                    <b-button @click="generateExcel"
                                        class="btn-sm ms-5 me-2 akkurate-green-btn akkurate-small">
                                        <font-awesome-icon :icon="['fas', 'file-excel']" />
                                    </b-button>
                                    <b-button class="me-2 btn-sm akkurate-green-btn akkurate-small" title="Filter"
                                        v-b-modal.modal-transaction>
                                        <span class="akkurate-small"><font-awesome-icon
                                                :icon="['fas', 'filter']" /></span>
                                    </b-button>

                                    <b-button @click="printPDF"
                                        class="me-2 btn-sm akkurate-green-btn akkurate-small"><font-awesome-icon
                                            :icon="['fas', 'print']" /></b-button>
                                    <b-button @click="downloadPDF"
                                        class="btn-sm akkurate-green-btn akkurate-small"><font-awesome-icon
                                            :icon="['fas', 'download']" /></b-button>
                                </div>
                            </div>
                        </div>

                        <b-modal size="lg" id="modal-transaction" @ok="handleOk">
                            <template #modal-title>
                                <h6 class="fw-bold mb-0 akkurate-green">Filter</h6>
                            </template>
                            <form @submit.prevent="basicSearch">
                                <basic-search :filter="filter" :branches="branches" :fd_scheme="fd_scheme"
                                    :show_search="false"></basic-search>
                            </form>
                            <template #modal-footer="{ ok }">

                                <div class="w-100">
                                    <!-- Emulate built in modal footer ok and cancel button actions -->
                                    <b-button @click="$bvModal.hide('modal-transaction')" type="button"
                                        class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span
                                            class="small"><font-awesome-icon class="me-2"
                                                :icon="['fas', 'close']" />Cancel
                                        </span></b-button>
                                    <b-button @click="ok()" type="submit" :disabled="isSaving"
                                        class="akkurate-green-btn btn-size float-right border-0"><span
                                            class="small"><font-awesome-icon class="me-2"
                                                :icon="['fas', 'search']" />Search</span></b-button>
                                </div>
                            </template>
                        </b-modal>

                        <div class="card-body" ref="pdfContent">
                            <div class="row">
                                <div class="col-12 col-md-12">
                                    <statement-institution :institution="institution" :current_date="false"
                                        :title="getTitle"></statement-institution>
                                </div>
                                <hr />
                                <div class="col-6 row mb-2">
                                    <div class="col-12 small">
                                        Branch(es) : <span class="fw-bold">{{ branch_list }}</span>
                                    </div>
                                </div>

                                <div class="row col-6">
                                    <div class="col-md-12 col-12 text-end bd-highlight">
                                        <span class="mt-2"> From:
                                            <strong>{{ form.start_date }}</strong>
                                            To:
                                            <strong>{{ form.end_date }}</strong>
                                        </span>

                                    </div>
                                </div>
                            </div>

                            <div v-if="isBusy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-12 trans_details">
                                    <b-table striped bordered responsive id="fixed-deposit-table" :busy.sync="isBusy"
                                        :items="items" :fields="columns" :tbody-tr-class="rowClass" show-empty>
                                        <template #table-busy>
                                            <div class="text-center text-danger my-2">
                                                <b-spinner class="align-middle"></b-spinner>
                                                <strong>Loading...</strong>
                                            </div>
                                        </template>
                                        <template #empty="scope">
                                            <h4 class="text-center small mt-3">
                                                {{ scope.emptyText }}
                                            </h4>
                                        </template>
                                        <template #cell(customer_full_name)="data">
                                            <div>
                                                {{ data.item.customer.first_name }}
                                                {{ data.item.customer.last_name }}
                                            </div>
                                        </template>
                                        <template #cell(principal)="data">
                                            <div>
                                                {{ institution?.currency_code }} {{
                                                    displayNumber(
                                                        data.item?.fixed_deposit
                                                            ?.principal_amount
                                                    )
                                                }}
                                            </div>
                                        </template>
                                        <template #cell(interest_expected)="data">
                                            <div>
                                                {{ institution?.currency_code }} {{
                                                    displayNumber(
                                                        data.item.fixed_deposit
                                                            ?.interest_expected
                                                    )
                                                }}
                                            </div>
                                        </template>
                                        <template #cell(maturity_value)="data">
                                            <span>
                                                {{ institution?.currency_code }} {{
                                                    displayNumber(
                                                        data.item?.fixed_deposit
                                                            ?.maturity_value
                                                    )
                                                }}</span>
                                        </template>
                                        <template #cell(fixed_deposit.maturity_date)="data">
                                            <span>{{
                                                formatDateAndTime(data.item.fixed_deposit?.maturity_date)
                                                }}</span>
                                        </template>
                                        <template #cell(fixed_deposit.expected_start_date)="data">
                                            <span>{{
                                                formatDateAndTime(data.item.fixed_deposit?.expected_start_date)
                                                }}</span>
                                        </template>
                                        <template #cell(duration)="data">
                                            <div class="akkurate-dark">
                                                {{
                                                    calculateDuration(
                                                        new Date(
                                                            data.item.expected_start_date
                                                        ),
                                                        new Date(
                                                            data.item.maturity_date
                                                        )
                                                    )
                                                }}
                                            </div>
                                        </template>

                                        <template #cell(fixed_deposit.daily_interest)="data">
                                            <div>
                                                {{ institution?.currency_code }}
                                                {{
                                                    displayNumber(
                                                        data.item.fixed_deposit
                                                            ?.daily_interest
                                                    )
                                                }}
                                            </div>
                                        </template>

                                        <template #cell(fixed_deposit.interest_due)="data">
                                            <div>
                                                {{ institution?.currency_code }}
                                                {{
                                                    displayNumber(
                                                        data.item.fixed_deposit
                                                            ?.interest_due
                                                    )
                                                }}
                                            </div>
                                        </template>
                                    </b-table>
                                </div>
                                <div class="col-md-12 trans_details">
                                    <div class="d-flex justify-content-between">
                                        <b-pagination class="mt-1" @change="navigatePage" v-model="currentPage"
                                            :total-rows="totalRecords" :per-page="perPage"
                                            aria-controls="member-table"></b-pagination>
                                        <div class="col text-end mt-1 akkurate-dark">
                                            <div>
                                                {{ currentPage }} -
                                                {{ perPage }} of
                                                {{ totalRecords }}
                                            </div>
                                            <b-form-group label="Per Page" label-size="sm" class="mb-0">
                                                <b-form-select @change="selectPerPage" id="per-page-select"
                                                    v-model="perPage" :options="per_page_options"
                                                    size="sm"></b-form-select>
                                            </b-form-group>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <footer></footer>
        </div>

        <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
        <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
    </div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import StatementInstitution from "@/views/main/components/institution/StatementInstitution.vue";
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import html2pdf from "html2pdf.js";
import ReportFilter from "@/views/main/pages/reports/form/ReportFilter.vue";
import BasicSearch from "../../investment/fixed-deposit/form/BasicSearch.vue";
import ExcelJS from "exceljs";
import ChatBot from "@/views/components/AI/ChatBot.vue";
export default {
    components: {
        SidebarView,
        TopbarView,
        Footer,
        StatementInstitution,
        Multiselect,
        ReportFilter,
        BasicSearch,
        ChatBot,
    },
    created() {
        this.loadItems();
        this.getInsistution();
        this.getDropdown();
    },
    data() {
        return {

            form: {
                start_date: this.getOneMonthEailer(),
                end_date: new Date().toISOString().substr(0, 10),
                branches: [],
                products: [],
                branch_options: [],
                product_options: [],
                users: [],
                users_options: [],
                status: [],
                coa: [],
                coa_options: [],
                terms: "Periodic",
                terms_options: ["YTD", "Periodic"],
                categories: [],
                payment: "Cash",
                loan_status:[],
            },
            filter: {
                branches: true,
                products: false,
                users: false,
                status: false,
                condition: false,
                coa: true,
                terms: true,
                start_date: true,
                end_date: true,
                code: "",
                search: "",
                status: "",
                from_date: "",
                to_date: "",
                branch: "",
                trans_source: "",
                branch_option: [],
                fixed_deposit_scheme: "",
                loan_status: false,
            },
            institution: "",

            user_role: "",
            user_pemissions: "",
            current_user_id: "",
            currentFdData: "",
            branches: {},
            liquid_funds: {},
            fd_scheme: [],
            bank_currents: {},
            isBusy: true,
            totals: {
                total_deposits: "",
                total_expected_interest: "",
                total_maturity_value: "",
                total_interest_accrued: "",
            },
            // advSearch: {},
            // action: {
            //     search_btn: "Search",
            //     disabled_search: false,
            // },
            columns: [
                {
                    label: "FD #",
                    key: "fixed_deposit.code",
                },
                {
                    label: "Scheme",
                    key: "fixed_deposit.fixed_deposit_product.name",
                },
                {
                    label: "Member Name",
                    key: "customer_full_name",
                },
                {
                    label: "Principal",
                    key: "principal",
                },
                {
                    label: "Expected Interest",
                    key: "interest_expected",
                },
                {
                    label: "Duration",
                    key: "fixed_deposit.current_duration",
                },
                {
                    label: "Maturity.VAL",
                    key: "maturity_value",
                },
                {
                    label: "Maturity Date",
                    key: "fixed_deposit.maturity_date",
                },
                {
                    label: "Rate",
                    key: "fixed_deposit.interest_rate",
                },
                {
                    label: "Tenure",
                    key: "fixed_deposit.tenor",
                },
                {
                    label: "Start Date",
                    key: "fixed_deposit.expected_start_date",
                },
                {
                    label: "Status",
                    key: "fixed_deposit.status",
                },
                {
                    label: "Mandate",
                    key: "fixed_deposit.fixed_deposit_mandate",
                },
                {
                    label: "Daily interest",
                    key: "fixed_deposit.daily_interest",
                },
                {
                    label: "Interest due",
                    key: "fixed_deposit.interest_due",
                }
            ],
            items: [],
            isLoading: false,
            totalRecords: 0,
            currentFDId: "",
            start_date: "",
            end_date: "",
            branch_list: "",
            isSaving: false,
            per_page_options: ["10", "20", "50", "100", "500"],
            currentPage: 1,
            perPage: 10,
            totalRecords: 0,
        };
    },
    computed: {
        getTitle() {
            let title = "Fixed-Term Deposit Reports";
            if (this.filter.status) {
                title += ` - ${this.filter.status}`;
            }
            // if (this.filter.branch) {
            //     title += ` - ${this.filter.branch}`;
            // }
            // if (this.filter.trans_source) {
            //     title += ` - ${this.filter.trans_source.name}`;
            // }
            // if (this.start_date && this.end_date) {
            //     title += ` from ${this.start_date} to ${this.end_date}`;
            // }
            return title;
        },
    },
    methods: {
        rowClass() {
            return "custom-row-height";
        },
        navigatePage(index) {
            this.isBusy = true;
            this.currentPage = index;
            this.loadItems();
        },
        selectPerPage(index) {
            this.perPage = index;
            this.loadItems();
        },
        // load items is what brings back the rows from server
        async loadItems() {
            this.isBusy = true; // Set isBusy to true when data is being loaded
            this.$Progress.start();
            this.isLoading = true;


            if (this.filter.from_date) {
                this.form.start_date = this.filter.from_date;
            } else {
                this.start_date = this.getOneMonthEailer();
            }

            if (this.filter.to_date) {
                this.form.end_date = this.filter.to_date;
            } else {
                this.end_date = new Date().toISOString().substr(0, 10);
            }

            await ApiService.query("/investments/fixed-term-deposits", {
                params: {
                    page: this.currentPage,
                    per_page: this.perPage,
                    branch_ids: this.filter.branch, //ie fixed deposit number
                    start_date: this.filter.from_date,
                    end_date: this.filter.to_date,
                    status: this.filter.status, // "COMPLETED", "PENDING", "FAILED"
                    filter: this.filter.search,
                    branch_ids: this.filter.branch,
                    fixed_deposit_scheme:
                        this.filter.fixed_deposit_scheme?.id,
                },
            })
                .then((response) => {
                    // console.log(response.data.data.data);
                    this.items = response.data.data.data;
                    this.totalRecords = response.data.data.total;
                    this.isLoading = false;
                    this.isBusy = false; // Set isBusy to false when the data is loaded
                    this.$Progress.finish(); // Finish the progress bar
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                    this.isBusy = false; // Set isBusy to false when the data is loaded
                    this.$Progress.finish(); // Finish the progress bar
                });
        },

        async getDropdown() {
            await ApiService.get(
                "/investments/fixed-term-deposits/dropdown"
            )
                .then((response) => {
                    this.branches = response.data.branches;
                    this.liquid_funds = response.data.liquid_funds;
                    this.fd_scheme = response.data.fd_scheme;
                    this.bank_currents = response.data.bank_currents;

                    response.data.branches.forEach((branch, i) => {
                        this.branch_list = this.branch_list + (i != 0 ? ", " : "") + branch.name
                    });

                    // this.product_options = response.data.coa_subheads;
                    // console.log(response.data.coa_subheads);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async getInsistution() {
            await ApiService.get("/settings/institution")
                .then((response) => {
                    // console.log(response);
                    this.institution = response.data.data;
                    console.log("Institution Data:", this.institution);
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        approvedFD() {
            this.$bvModal.hide("fd-modal-" + this.currentFDId);
            this.loadItems();
        },
        downloadPDF() {
            const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
            // console.log("here");
            const pdfOptions = {
                margin: [5, 5, 5, 2], //top, left, buttom, right
                filename: "statement.pdf",
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2 },

                jsPDF: {
                    unit: "mm",
                    format: "A4",
                    orientation: "landscape",
                },
            };
            html2pdf()
                .from(content)
                .set(pdfOptions)
                .toPdf()
                .get("pdf")
                .then((pdf) => {
                    var totalPages = pdf.internal.getNumberOfPages();
                    var insit_name = this.institution.name;
                    var insit_tele = this.institution.telephone;
                    var insit_email = this.institution.email;
                    var insit_motto = this.institution.motto;

                    for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(8);
                        pdf.setTextColor(150);
                        pdf.text(
                            [
                                "For Inquiries, Please Contact " +
                                insit_name +
                                ", Customer Service on " +
                                insit_tele +
                                "",
                                "or email us on " +
                                insit_email +
                                " " +
                                insit_motto +
                                "",
                                "Page " + i + " of " + totalPages,
                            ],
                            pdf.internal.pageSize.getWidth() / 2,
                            pdf.internal.pageSize.getHeight() - 0.6,
                            { align: "center" }
                        );
                    }
                })
                .save();
        },
        printPDF() {
            const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
            console.log(content)
            // console.log("here");
            const pdfOptions = {
                margin: [5, 5, 5, 2], //top, left, buttom, right
                filename: "statement.pdf",
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2 },

                jsPDF: {
                    unit: "mm",
                    format: "A4",
                    orientation: "landscape",
                },
            };
            html2pdf()
                .from(content)
                .set(pdfOptions)
                .toPdf()
                .get("pdf")
                .then((pdf) => {
                    var totalPages = pdf.internal.getNumberOfPages();
                    var insit_name = this.institution.name;
                    var insit_tele = this.institution.telephone;
                    var insit_email = this.institution.email;
                    var insit_motto = this.institution.motto;
                    for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(8);
                        pdf.setTextColor(150);
                        pdf.text(
                            [
                                "For Inquiries, Please Contact " +
                                insit_name +
                                ", Customer Service on " +
                                insit_tele +
                                "",
                                "or email us on " +
                                insit_email +
                                " " +
                                insit_motto +
                                "",
                                "Page " + i + " of " + totalPages,
                            ],
                            pdf.internal.pageSize.getWidth() / 2,
                            pdf.internal.pageSize.getHeight() - 0.6,
                            { align: "center" }
                        );
                    }
                    // Get the blob of the PDF
                    return pdf.output("blob");
                })
                .then((pdfBlob) => {
                    // Create a URL for the PDF blob
                    var pdfUrl = URL.createObjectURL(pdfBlob);

                    // Open the URL in a new tab
                    const printWindow = window.open(
                        pdfUrl,
                        "_blank",
                        "width=800,height=600"
                    );
                    printWindow.onload = () => {
                        printWindow.print();
                        URL.revokeObjectURL(pdfUrl);
                    };
                })
                .catch((error) => {
                    console.error("Error generating PDF:", error);
                });
        },
        filterTable() {
            this.getReceiptListing();
        },
        filterAction() {
            this.getVoucherListing();
            console.log(this.form);
        },
        submitFormFilters() {
            this.loadItems();
            this.coa_name = this.form.users.map(index => {
                return `${index.first_name} ${index.surname}`;
            }).join(', ');
        },
        handleOk(bvModalEvent) {
            this.submitFormFilters()
        },
        changePerPageNumber(data) {
            this.perPage = data;
            this.getReceiptListing();
        },
        async getInstitution() {
            this.isLoadingInstitution = true;
            await ApiService.get("/settings/institution")
                .then((response) => {
                    this.institution = response.data.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.isLoadingInstitution = false;
                });
        },
        calculateDuration(startDate, endDate) {
            // Convert both dates to milliseconds
            const startMillis = startDate.getTime();
            const endMillis = endDate.getTime();

            // Calculate the difference in milliseconds
            let durationMillis = Math.abs(endMillis - startMillis);

            // Calculate the duration in days, hours, minutes, and seconds
            const millisecondsInDay = 1000 * 60 * 60 * 24;
            const days = Math.floor(durationMillis / millisecondsInDay);
            durationMillis %= millisecondsInDay;
            // const hours = Math.floor(durationMillis / (1000 * 60 * 60));
            // durationMillis %= (1000 * 60 * 60);
            // const minutes = Math.floor(durationMillis / (1000 * 60));
            // durationMillis %= (1000 * 60);
            // const seconds = Math.floor(durationMillis / 1000);

            // Return an object with the duration components
            return days;
            // return {
            //     days: days,
            //     hours: hours,
            //     minutes: minutes,
            //     seconds: seconds
            // };
        },
        async generateExcel() {
  const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx";
  const imageUrl = "/default_logo.png";

  const institutionName = this.institution.name || '';
  const institutionMotto = this.institution.motto || '';
  const institutionAddress = this.institution.address || '';
  const institutionPhone = this.institution.telephone || '';
  const institutionEmail = this.institution.email || '';
  const dateRange = `FROM: ${this.filter.from_date || this.getOneMonthEailer()} TO: ${this.filter.to_date || new Date().toISOString().substr(0, 10)}`;
  const branchList = this.branch_list || 'All Branches';

  try {
    // Load the Excel template
    const response = await fetch(fileUrl);
    if (!response.ok) throw new Error(`Network response was not ok: ${response.statusText}`);
    const arrayBuffer = await response.arrayBuffer();

    const wb = new ExcelJS.Workbook();
    await wb.xlsx.load(arrayBuffer);
    const ws = wb.getWorksheet(1);

    // Add institution logo if available
    try {
      const imageResponse = await fetch(imageUrl);
      if (imageResponse.ok) {
        const imageBuffer = await imageResponse.arrayBuffer();
        const imageId = wb.addImage({ buffer: imageBuffer, extension: "png" });
        ws.addImage(imageId, { tl: { col: 0, row: 0 }, ext: { width: 300, height: 200 } });
      }
    } catch (imageError) {
      console.warn("Could not load image:", imageError);
    }

    // Add institution details
    const startRow = 1;
    ws.getCell(`L${startRow}`).value = institutionName;
    ws.getCell(`L${startRow}`).font = { bold: true, size: 14 };
    ws.getCell(`L${startRow + 1}`).value = institutionAddress;
    ws.getCell(`L${startRow + 1}`).font = { size: 12 };
    ws.getCell(`L${startRow + 2}`).value = institutionMotto;
    ws.getCell(`L${startRow + 2}`).font = { size: 12 };
    ws.getCell(`L${startRow + 3}`).value = institutionPhone;
    ws.getCell(`L${startRow + 3}`).font = { size: 12 };
    ws.getCell(`L${startRow + 4}`).value = institutionEmail;
    ws.getCell(`L${startRow + 4}`).font = { size: 12 };
    ws.getCell(`L${startRow + 6}`).value = dateRange;
    ws.getCell(`L${startRow + 6}`).font = { size: 12 };
    ws.getCell(`L${startRow + 7}`).value = `Branch(es): ${branchList}`;
    ws.getCell(`L${startRow + 7}`).font = { size: 12 };
    ws.getColumn("L").width = 50;

    // Add headers for the fixed deposit table
    const headerRowNum = 13;
    const headerRow = ws.getRow(headerRowNum);
    headerRow.values = [
      "FD #",
      "Scheme",
      "Member Name",
      "Principal",
      "Expected Interest",
      "Duration (Days)",
      "Maturity Value",
      "Maturity Date",
      "Rate (%)",
      "Tenure",
      "Start Date",
      "Status",
      "Mandate",
      "Daily Interest",
      "Interest Due"
    ];
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: "center" };
    headerRow.commit();

    let currentRowNum = headerRowNum + 1;

    // Loop through fixed deposit items and add rows
    for (const item of this.items) {
      const row = ws.getRow(currentRowNum);
      const fd = item.fixed_deposit || {};
      
      row.getCell(1).value = fd.code || '';
      row.getCell(2).value = fd.fixed_deposit_product?.name || '';
      row.getCell(3).value = `${item.customer?.first_name || ''} ${item.customer?.last_name || ''}`;
      row.getCell(4).value = Number(fd.principal_amount || 0);
      row.getCell(5).value = Number(fd.interest_expected || 0);
      row.getCell(6).value = fd.current_duration || 0;
      row.getCell(7).value = Number(fd.maturity_value || 0);
      row.getCell(8).value = fd.maturity_date ? this.formatDateAndTime(fd.maturity_date) : '';
      row.getCell(9).value = fd.interest_rate || 0;
      row.getCell(10).value = fd.tenor || '';
      row.getCell(11).value = fd.expected_start_date ? this.formatDateAndTime(fd.expected_start_date) : '';
      row.getCell(12).value = fd.status || '';
      row.getCell(13).value = fd.fixed_deposit_mandate || '';
      row.getCell(14).value = Number(fd.daily_interest || 0);
      row.getCell(15).value = Number(fd.interest_due || 0);
      
      row.commit();
      currentRowNum++;
    }

    // Set column widths for better readability
    ws.getColumn(1).width = 15;   // FD #
    ws.getColumn(2).width = 20;   // Scheme
    ws.getColumn(3).width = 25;   // Member Name
    ws.getColumn(4).width = 15;   // Principal
    ws.getColumn(5).width = 18;   // Expected Interest
    ws.getColumn(6).width = 12;   // Duration
    ws.getColumn(7).width = 15;   // Maturity Value
    ws.getColumn(8).width = 18;   // Maturity Date
    ws.getColumn(9).width = 10;   // Rate
    ws.getColumn(10).width = 10;  // Tenure
    ws.getColumn(11).width = 18;  // Start Date
    ws.getColumn(12).width = 15;  // Status
    ws.getColumn(13).width = 15;  // Mandate
    ws.getColumn(14).width = 15;  // Daily Interest
    ws.getColumn(15).width = 15;  // Interest Due

    // Generate and download Excel file
    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Fixed_Term_Deposit_Report_${new Date().toISOString().slice(0, 10)}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);

  } catch (err) {
    console.error("Error generating Excel file:", err);
    this.$bvToast.toast('Failed to generate Excel file. Please try again.', {
      title: 'Export Error',
      variant: 'danger',
      solid: true
    });
  }
}
        
    },
};
</script>
